/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '@kubb/plugin-client/clients/fetch';
import type {
  RecordHeartbeatPostMutationResponse,
  RecordHeartbeatPostPathParams,
  RecordHeartbeatPost404,
  RecordHeartbeatPost409,
} from '../types/RecordHeartbeatPost.ts';
import type { Client, RequestConfig, ResponseErrorConfig } from '@kubb/plugin-client/clients/fetch';

function getRecordHeartbeatPostUrl(token: RecordHeartbeatPostPathParams['token']) {
  const res = { method: 'POST', url: `/heartbeat/${token}` as const };
  return res;
}

/**
 * @summary Record a heartbeat check-in (POST variant)
 * {@link /heartbeat/:token}
 */
export async function recordHeartbeatPost(
  token: RecordHeartbeatPostPathParams['token'],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    RecordHeartbeatPostMutationResponse,
    ResponseErrorConfig<RecordHeartbeatPost404 | RecordHeartbeatPost409>,
    unknown
  >({ method: 'POST', url: getRecordHeartbeatPostUrl(token).url.toString(), ...requestConfig });
  return res.data;
}
